import { DateDistribution } from '../../../shared/models/context-insights/ContextInsightsResponse';
import { PeriodType } from '../../../shared/types/prompt/PeriodType';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { createSentimentChartMatrix } from '../helpers/ContextAnalysisHelper';

export const useSentimentChartMatrix = (dateDistribution: DateDistribution[], period: PeriodType) => {
  const { t } = useTranslation();

  return useMemo(
    () => createSentimentChartMatrix(period, dateDistribution, t),
    [dateDistribution, period, t]
  );
};
